"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
//
// assets
//
const appsCopy_1 = require("copy/appsCopy");
const malomo_png_1 = __importDefault(require("assets/images/dashboard/apps/malomo.png"));
const shopify_png_1 = __importDefault(require("assets/images/dashboard/apps/shopify.png"));
const klaviyo_png_1 = __importDefault(require("assets/images/dashboard/apps/klaviyo.png"));
const postscript_png_1 = __importDefault(require("assets/images/dashboard/apps/postscript.png"));
const attentive_png_1 = __importDefault(require("assets/images/dashboard/apps/attentive.png"));
const loop_png_1 = __importDefault(require("assets/images/dashboard/apps/loop.png"));
const gorgias_png_1 = __importDefault(require("assets/images/dashboard/apps/gorgias.png"));
const rebuy_png_1 = __importDefault(require("assets/images/dashboard/apps/rebuy.png"));
//
// styles
//
const StyledConnectedIcon_1 = require("./StyledConnectedIcon");
const StyledSectionText_1 = require("components/Dashboard/StyledSectionText");
const MalomoText_1 = require("components/Dashboard/MalomoText");
const Flex_1 = require("components/Dashboard/Flex");
const StyledAppContainer_1 = require("./StyledAppContainer");
const StyledTextContainer_1 = require("./StyledTextContainer");
const polaris_1 = require("@shopify/polaris");
const logos = {
    shopify: shopify_png_1.default,
    klaviyo: klaviyo_png_1.default,
    postscript: postscript_png_1.default,
    attentive: attentive_png_1.default,
    loop: loop_png_1.default,
    gorgias: gorgias_png_1.default,
    rebuy: rebuy_png_1.default
};
function openLink(url) {
    window.open(url, '_blank');
}
function logoSrc(name) {
    return logos[name] || malomo_png_1.default;
}
const AppModule = ({ app, onUninstall }) => {
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    // when adding a new feature flag it should match the name of the integration.
    // In some cases where the name is more than one word we may need to do more
    // than just lowercase
    if (flags[app.name.toLowerCase()] === false) {
        return null;
    }
    return (react_1.default.createElement(polaris_1.Card, { sectioned: true },
        react_1.default.createElement(StyledAppContainer_1.StyledAppContainer, null,
            react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
                react_1.default.createElement(polaris_1.Thumbnail, { alt: app.name, source: logoSrc(app.name.toLowerCase()) }),
                react_1.default.createElement(StyledTextContainer_1.StyledTextContainer, null,
                    react_1.default.createElement(StyledSectionText_1.StyledSectionText, { className: 'app-name' }, app.name),
                    react_1.default.createElement(MalomoText_1.MalomoText, { className: 'app-category', gray: true, paragraph: true, small: true }, app.category),
                    app.installed && (react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
                        react_1.default.createElement(StyledConnectedIcon_1.StyledConnectedIcon, null),
                        react_1.default.createElement(MalomoText_1.MalomoText, { className: 'connected', paragraph: true, small: true }, appsCopy_1.appsCopy.appConnected))))),
            react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true }, app.installed ? (react_1.default.createElement(polaris_1.ButtonGroup, null,
                react_1.default.createElement(polaris_1.Button, { id: 'uninstall-button', onClick: () => onUninstall(app.clientId) }, appsCopy_1.appsCopy.uninstall),
                react_1.default.createElement(polaris_1.Button, { id: 'reinstall-button', onClick: () => openLink(app.installUrl), primary: true }, appsCopy_1.appsCopy.reinstall))) : (react_1.default.createElement(polaris_1.Button, { id: 'install-button', onClick: () => openLink(app.installUrl), primary: true }, appsCopy_1.appsCopy.install))))));
};
exports.default = AppModule;
